import React from "react";
import { Box, Typography } from "@mui/material";

type Props = {
  items: string[];
};

export const Tiles = ({ items }: Props) => (
  <>
    {items.map((item) => (
      <Box
        key={item}
        sx={{
          p: 2,
          display: "flex",
          bgcolor: "grey.100",
          borderRadius: 1,
        }}
        data-testid="tile-item"
      >
        <Typography variant="body1">{item}</Typography>
      </Box>
    ))}
  </>
);
